export default __webpack_public_path__ + "static/media/2.47d1dcab.JPG";